import { MakePaymentCard } from "../../../UI-Component-Library";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "../../../custom-axios";
import { saveCartData } from "../../../redux/reducers/membership-purchase-reducer";
import { ApiConstants } from "../../../utils/api-constants";
import { AppUtils } from "../../../utils/app-utils";
import { DataLayerUtils } from "../../../utils/dataLayer-utils";
import { MembershipPurchaseUtils } from "../membership/membership-purchase.util";
class MakePaymentWrapper extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedCard: "",
      errorMessage: "",
      isPayingWithDifferentCard: false,
      shouldDisable: false,
      existingCards: [],
      annualProduct: {},
      combinedProduct: {},
      petMedAlertProduct: {},
      vetHelplineProduct: {},
      directConnectProduct: {},
      petcademyProduct: {},
      annualAutoRenew: {
        isChecked: true,
        showCheckbox: false,
      },
      combinedAutoRenew: {
        isChecked: false,
        showCheckbox: false,
      },
      petMedAlertAutoRenew: {
        isChecked: false,
        showCheckbox: false,
      },
      vetHelplineAutoRenew: {
        isChecked: false,
        showCheckbox: false,
      },
      directConnectAutoRenew: {
        isChecked: false,
        showCheckbox: false,
      },
      petcademyAutoRenew: {
        isChecked: false,
        showCheckbox: false,
      },
    };
    this.cRef = React.createRef();
  }
  proccedToCheckout() {
    const cartData = this.props.cartData;
    const orderItems = this.props.extractCartData(cartData, true);
    if (
      this.state.isPayingWithDifferentCard ||
      this.state.existingCards?.length === 0
    ) {
      DataLayerUtils.beginCheckoutEvent(orderItems, cartData?.total);
      this.props.history.push({
        pathname:"/pages/payment",
        state: orderItems
      });
    }

    const selectedCard = this.state.existingCards.find(
      (card) => card.active === true
    );
    const errorMessage = !selectedCard ? "Card is not selected" : "";
    this.setState({
      errorMessage,
    });
    if (!errorMessage && this.props.cartData) {
      axios
        .processPost(
          `${ApiConstants.URL_CHECKOUT_SHOPPING_CART}${this.props.cartData.cartId}`,
          this.cRef,
          {
            token: selectedCard.tokenId,
            cardType: selectedCard.cardType,
            maskedCardNumber: selectedCard.ccLastFour,
            countrycode: AppUtils.getCountryCode(),
          }
        )
        .then((response) => {
          this.props.history.push({
            pathname: "/pages/payment/success",
            state: orderItems
          });
        })
        .catch((err) => {
          let errors = err?.response?.data?.errors;
          if (errors && errors.length > 0) {
            this.setState({
              errorMessage: errors[0],
            });
          }
        });
    }
  }
  handleCardSelection(
    tokenId,
    resetAll = false,
    isPayingWithDifferentCard = false
  ) {
    DataLayerUtils.selectPaymentMethodEvent(AppUtils.getUserRelationId());
    const existingCards = this.state.existingCards.map((card) => {
      return {
        ...card,
        active: AppUtils.isEqualString(card.tokenId, tokenId) && !resetAll,
      };
    });
    this.setState({
      existingCards,
      isPayingWithDifferentCard: isPayingWithDifferentCard,
    });
  }
  handleNewCardSelection() {
    this.handleCardSelection("", true, !this.state.isPayingWithDifferentCard);
  }
  fetchCreditCards() {
    axios
      .processGet(
        `${ApiConstants.URL_DISPLAY_CC_CARDS}${AppUtils.getBusRelAccount()}`,
        this.cRef
      )
      .then((response) => {
        const cards = response.data;
        const existingCards = [];
        cards.forEach((card) => {
          existingCards.push({
            active: false,
            onClick: () => {
              this.handleCardSelection(card.tokenId);
            },
            description: `${card.paymMode} •••• ${card.ccLastFour}`,
            tokenId: card.tokenId,
            cardType: card.paymMode,
            ccLastFour: card.ccLastFour,
          });
        });
        this.setState({
          existingCards,
        });
      })
      .catch((err) => {
        let errors = err?.response?.data?.errors;
        if (errors && errors.length > 0) {
          this.setState({
            errorMessage: errors[0],
          });
        }
      });
  }
  setAutoRenewFlags() {
    let cartData = this.props?.cartItems;
    if (cartData && cartData.orderLines) {
      let showDirectConnect = false,
        showPetcademy = false,
        showPetMedAlert = false,
        showVetHelpline = false,
        showCombineProduct = false,
        showAnnualProduct = false;
      let annualProduct = {},
        combinedProduct = {},
        petMedAlertProduct = {},
        vetHelplineProduct = {},
        directConnectProduct = {},
        petcademyProduct = {};
      for (let order of cartData?.orderLines) {
        // Set autorenew checkbox checked/unchecked based on api response.
        if (
          AppUtils.isEqualString(
            AppUtils.getAlreadyPurchasedAnnualProductName(order.itemId),
            'Annual Protection Membership'
          )
        ) {
          showAnnualProduct = true;
          annualProduct = order;
        }
        if ((AppUtils.isEqualString(order.itemType, 'LPMBundleProduct')
          || AppUtils.isEqualString(order.itemType, 'LPMPLUSBundleProduct')) &&
          AppUtils.isEqualString(order.itemId, "WD Annual Membership")
        ) {
          showCombineProduct = true;
          combinedProduct = order;
        }
        if (
          AppUtils.isEqualString(order.itemType, 'SubscriptionProduct') &&
          ( AppUtils.isEqualString(order.itemId, "PetMedInfo Fees") ||
          AppUtils.isEqualString(order.itemId, "PetMedAlert_Sub"))
        ) {
          showPetMedAlert = true;
          petMedAlertProduct = order;
        }
        if (
          AppUtils.isEqualString(order.itemType, 'SubscriptionProduct') &&
          (AppUtils.isEqualString(order.itemId, "WD Annual Membership") ||
          AppUtils.isEqualString(order.itemId, "WhiskerDoc_Service"))
        ) {
          showVetHelpline = true;
          vetHelplineProduct = order;
        }
        if (AppUtils.isEqualString(order.itemType, 'SubscriptionProduct') &&
          AppUtils.isEqualString(order.itemId, "DirectConnect")) {
          showDirectConnect = true;
          directConnectProduct = order;
        }
        if (AppUtils.isEqualString(order.itemType, 'SubscriptionProduct') &&
          AppUtils.isEqualString(order.itemId, "Petcademy_Subption")) {
          showPetcademy = true;
          petcademyProduct = order;
        }
      }

      this.setState({
        annualAutoRenew: { ...this.state.annualAutoRenew, showCheckbox: showAnnualProduct, isChecked: annualProduct.autoRenew !== 0 },
        petMedAlertAutoRenew: { ...this.state.petMedAlertAutoRenew, showCheckbox: showPetMedAlert, isChecked: petMedAlertProduct.autoRenew !== 0 },
        vetHelplineAutoRenew: { ...this.state.vetHelplineAutoRenew, showCheckbox: showVetHelpline, isChecked: vetHelplineProduct.autoRenew !== 0},
        directConnectAutoRenew: { ...this.state.directConnectAutoRenew, showCheckbox: showDirectConnect, isChecked: directConnectProduct.autoRenew !== 0 },
        petcademyAutoRenew: { ...this.state.petcademyAutoRenew, showCheckbox: showPetcademy, isChecked: petcademyProduct.autoRenew !== 0 },
        combinedAutoRenew: { ...this.state.combinedAutoRenew, showCheckbox: showCombineProduct, isChecked: combinedProduct.autoRenew !== 0 },
        annualProduct,
        combinedProduct,
        petMedAlertProduct,
        directConnectProduct,
        vetHelplineProduct,
        petcademyProduct
      })
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchCreditCards();
    this.setAutoRenewFlags();
  }
  componentDidUpdate(prevProps) {
    // Check if the prop changed
    if (prevProps.cartItems !== this.props.cartItems) {
      this.setAutoRenewFlags();
    }
  }

  getCartData() {
    axios
      .processGet(
        `${ApiConstants.URL_GET_CART_DATA}${AppUtils.getUserRelationId()}`,
        null
      )
      .then((cartData) => {
        this.props.saveCartData(cartData);
      })
      .catch((err) => {
        let errors = err?.response?.data?.errors;
        if (errors && errors.length > 0) {
          this.setState({
            errorMessage: errors[0],
          });
        }
      });
  }

  saveAutoRenewInfo(item) {
    axios
      .processPost(`${ApiConstants.URL_POST_SET_AUTO_RENEW_CART_ITEM}/${item.basketId}`, null, {
        itemId: item.itemId,
        autoRenew: item.autoRenew,
      })
      .then((response) => {
        this.getCartData();
      })
      .catch((err) => {});
  }

  getButtonDisableState = () => {
    let isAnnual = this.state.annualAutoRenew.showCheckbox && !this.state.annualAutoRenew.isChecked;
    let isCombined = this.state.combinedAutoRenew.showCheckbox && !this.state.combinedAutoRenew.isChecked;
    let isPetMed = this.state.petMedAlertAutoRenew.showCheckbox && !this.state.petMedAlertAutoRenew.isChecked;
    let isVetHelp = this.state.vetHelplineAutoRenew.showCheckbox && !this.state.vetHelplineAutoRenew.isChecked;
    let isDirect = this.state.directConnectAutoRenew.showCheckbox && !this.state.directConnectAutoRenew.isChecked;
    let isPetcademy = this.state.petcademyAutoRenew.showCheckbox && !this.state.petcademyAutoRenew.isChecked;

    return isAnnual || isCombined || isPetMed || isVetHelp || isDirect || isPetcademy;
  }
  render() {
    return (
      <div ref={this.cRef}>
        <MakePaymentCard
          caption={
            this.state.existingCards?.length > 0
              ? "Do you want to make a payment with your saved card?"
              : "You have no cards saved, click below to add a payment method"
          }
          errorMessage={this.state.errorMessage}
          existingCardOptions={this.state.existingCards}
          payWithDifferentCardOption={{
            hidden: this.state.existingCards?.length > 0 ? false : true,
            active: this.state.isPayingWithDifferentCard,
            onClick: () => {
              this.handleNewCardSelection();
            },
          }}
          annualCheckboxProps={{
            id: "annual-checkout-auto-renew",
            checked: this.state.annualAutoRenew.isChecked,
            showCheckbox: this.state.annualAutoRenew.showCheckbox,
            onChange: () => {
              this.setState({
                annualAutoRenew: { ...this.state.annualAutoRenew, isChecked: !this.state.annualAutoRenew.isChecked }
              }, () => {
                this.saveAutoRenewInfo({
                  itemId: this.state.annualProduct.itemId,
                  autoRenew: this.state.annualAutoRenew.isChecked,
                  basketId: this.state.annualProduct.basketLineId
                });
              })
            },
          }}
          petMedAlertCheckboxProps={{
            id: "petMed-checkout-auto-renew",
            checked: this.state.petMedAlertAutoRenew.isChecked,
            showCheckbox: this.state.petMedAlertAutoRenew.showCheckbox,
            onChange: () => {
              this.setState({
                petMedAlertAutoRenew: { ...this.state.petMedAlertAutoRenew, isChecked: !this.state.petMedAlertAutoRenew.isChecked }
              }, () => {
                this.saveAutoRenewInfo({
                  itemId: this.state.petMedAlertProduct.itemId,
                  autoRenew: this.state.petMedAlertAutoRenew.isChecked,
                  basketId: this.state.petMedAlertProduct.basketLineId
                });
              })
            },
          }}
          combinedProductCheckboxProps={{
            id: "combined-checkout-auto-renew",
            checked: this.state.combinedAutoRenew.isChecked,
            showCheckbox: this.state.combinedAutoRenew.showCheckbox,
            onChange: () => {
              this.setState({
                combinedAutoRenew: { ...this.state.combinedAutoRenew, isChecked: !this.state.combinedAutoRenew.isChecked }
              }, () => {
                this.saveAutoRenewInfo({
                  itemId: "WD Annual Membership, PLH_000010",
                  autoRenew: this.state.combinedAutoRenew.isChecked,
                  basketId: this.state.combinedProduct.basketLineId
                });
              })
            },
          }}
          vetHelplineCheckboxProps={{
            id: "vetHelp-checkout-auto-renew",
            checked: this.state.vetHelplineAutoRenew.isChecked,
            showCheckbox: this.state.vetHelplineAutoRenew.showCheckbox,
            onChange: () => {
              this.setState({
                vetHelplineAutoRenew: { ...this.state.vetHelplineAutoRenew, isChecked: !this.state.vetHelplineAutoRenew.isChecked }
              }, () => {
                this.saveAutoRenewInfo({
                  itemId: this.state.vetHelplineProduct.itemId,
                  autoRenew: this.state.vetHelplineAutoRenew.isChecked,
                  basketId: this.state.vetHelplineProduct.basketLineId
                });
              })
            },
          }}
          directConnectCheckboxProps={{
            id: "direct-checkout-auto-renew",
            checked: this.state.directConnectAutoRenew.isChecked,
            showCheckbox: this.state.directConnectAutoRenew.showCheckbox,
            onChange: () => {
              this.setState({
                directConnectAutoRenew: { ...this.state.directConnectAutoRenew, isChecked: !this.state.directConnectAutoRenew.isChecked }
              }, () => {
                this.saveAutoRenewInfo({
                  itemId: this.state.directConnectProduct.itemId,
                  autoRenew: this.state.directConnectAutoRenew.isChecked,
                  basketId: this.state.directConnectProduct.basketLineId
                });
              })
            },
          }}
          petcademyCheckboxProps={{
            id: "petcademy-checkout-auto-renew",
            checked: this.state.petcademyAutoRenew.isChecked,
            showCheckbox: this.state.petcademyAutoRenew.showCheckbox,
            onChange: () => {
              this.setState({
                petcademyAutoRenew: { ...this.state.petcademyAutoRenew, isChecked: !this.state.petcademyAutoRenew.isChecked }
              }, () => {
                this.saveAutoRenewInfo({
                  itemId: this.state.petcademyProduct.itemId,
                  autoRenew: this.state.petcademyAutoRenew.isChecked,
                  basketId: this.state.petcademyProduct.basketLineId
                });
              })
            },
          }}
          continueButtonProp={{
            label:
              this.state.existingCards?.length > 0
                ? "Continue"
                : "Add a credit card",
            disabled: this.props.disableCheckoutButton || this.getButtonDisableState(),
            id: "buttonId",
            onClick: () => {
              this.proccedToCheckout();
            },
          }}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const membershipPurchaseStore = state.membershipPurchaseStore;
  const customerProfileStore = state.customerProfileStore;

  return {
    cartData: membershipPurchaseStore.cartData,
    promoCode: membershipPurchaseStore.promoCode,
    customerAnimals: customerProfileStore.customerAnimals,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveCartData: (data) => dispatch(saveCartData(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MakePaymentWrapper));
